/**
 * O que faz: Lista artigos publicos filtrados por categoria para SEO e navegacao tematica.
 * Onde usa: Rota publica `/blog/categoria/:slug`.
 * Conexoes: Le parametro da URL e filtra itens do modulo `publicContent`.
 * Tabelas: Nao interage com Supabase; conteudo e estatico.
 * Data: 09/05/2026
 */

import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import PublicContentLayout from "@/components/blog/PublicContentLayout";
import ContentCard from "@/components/blog/ContentCard";
import { publicContent } from "@/content/generated/public-content";
import NotFound from "./NotFound";

const BlogCategoryPage = () => {
  const { slug } = useParams();
  const items = publicContent.filter((item) => item.type === "blog" && item.category === slug);

  if (!slug || items.length === 0) return <NotFound />;

  const canonical = `https://crm.agenciagens.com.br/blog/categoria/${slug}`;

  return (
    <PublicContentLayout title={`Categoria: ${slug}`} description="Conteudos filtrados por categoria para leitura focada.">
      <Helmet>
        <title>{`Categoria ${slug} | Blog Gens CRM`}</title>
        <meta name="description" content={`Artigos da categoria ${slug} no blog do Gens CRM.`} />
        <link rel="canonical" href={canonical} />
      </Helmet>
      <section className="public-section">
        <div className="public-grid">
          {items.map((item) => (
            <ContentCard key={item.slug} item={item} />
          ))}
        </div>
      </section>
    </PublicContentLayout>
  );
};

export default BlogCategoryPage;
